module.exports = __webpack_public_path__ + "img/swipe.7c87b340.svg";